import { ChangeResult } from '../../../change-result';
import { ExchangeReportProfileInboxRule } from '../../../microsoft/exchange/profile/exchange-report-profile-inbox-rule';

export class ExchangeReportProfileRulesChangesModel {
  forwardMailBoxesChanges: ChangeResult<string>;
  hasTransportRulesHasChanged: boolean;
  hasJournalRulesHasChanged: boolean;
  inboxRulesChanges: ChangeResult<ExchangeReportProfileInboxRule>;
}
